import axios from "axios";

const api_base_url =
  process.env.REACT_APP_API_BASEURL + "/OfficeApplianceBrand";

export const getOfficeApplianceBrands = async () => {
  const { data } = await axios.get(`${api_base_url}`);
  return data;
};
